import { render, staticRenderFns } from "./DatasetGroups.vue?vue&type=template&id=344dd3c9&scoped=true&"
import script from "./DatasetGroups.vue?vue&type=script&lang=js&"
export * from "./DatasetGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344dd3c9",
  null
  
)

export default component.exports